/**
 * CONFIGURACIÓN RESPONSIVE
 * Breakpoints y configuraciones específicas por dispositivo
 */

export const responsiveConfig = {
  breakpoints: {
    mobile: "768px",
    tablet: "1024px",
    desktop: "1280px",
  },
  mobile: {
    headerHeight: "60px",
    heroTitleSize: "clamp(1.5rem, 8vw, 3rem)",
    sectionPadding: "2rem 1rem",
    buttonSize: "small",
    gridCols: 1,
    maxWidth: "100%",
  },
  tablet: {
    headerHeight: "70px",
    heroTitleSize: "clamp(2rem, 6vw, 5rem)",
    sectionPadding: "3rem 2rem",
    buttonSize: "medium",
    gridCols: 2,
    maxWidth: "768px",
  },
  desktop: {
    headerHeight: "80px",
    heroTitleSize: "clamp(3rem, 5vw, 8rem)",
    sectionPadding: "4rem 3rem",
    buttonSize: "large",
    gridCols: 3,
    maxWidth: "1280px",
  },
};
